<script setup lang="ts">
import type { DSEProfile } from '../profile'

defineProps<{
  profile: DSEProfile
}>()
</script>

<template>
  <div>CustomButtonMapping (TODO)</div>
</template>

<style scoped></style>
